import {Pipe, PipeTransform} from "@angular/core";

/**
 * Wraps a function in a pipe.
 * This enables the function to be memoized, and only re-evaluated when the input changes.
 *
 * @example
 * ```html
 * <div>{{ myFunction | wrapFn: arg1:arg2:arg3 }}</div>
 * ```
 */
@Pipe({
	name: "wrapFn",
	standalone: false,
})
export class WrapFnPipe implements PipeTransform {
	transform<ARG, RET>(func: (arg: ARG) => RET, args: ARG): RET;
	transform<ARG1, ARG2, RET>(func: (arg1: ARG1, arg2: ARG2) => RET, arg1: ARG1, arg2: ARG2): RET;
	transform<ARG1, ARG2, ARG3, RET>(func: (arg1: ARG1, arg2: ARG2, arg3: ARG3) => RET, arg1: ARG1, arg2: ARG2, arg3: ARG3): RET;
	transform<ARG1, ARG2, ARG3, RET>(
		func: (arg1: ARG1, arg2: ARG2, arg3: ARG3, ...args: any[]) => RET,
		arg1: ARG1,
		arg2: ARG2,
		arg3: ARG3,
		...args: any[]
	): RET;

	transform<RET>(func: (...args: unknown[]) => RET, ...args: unknown[]): RET {
		return func(...args);
	}
}
